import React, { useState } from 'react';

import terminosPDF from '../terminos.pdf';
import privacyPDF from '../privacy.pdf';

const TerminosPrivacy = () => {

  const [selectedDocument, setSelectedDocument] = useState('terminos');

  return (
    <div className="min-h-screen bg-[#f5f0e8] px-4 py-10">

      <div className="mx-auto max-w-6xl">

        {/* HEADER */}
        <div className="mb-8 text-center">

          <h1
            className="mb-4 text-3xl text-[#1a3d1a] md:text-5xl"
            style={{
              fontFamily: "'Press Start 2P', monospace",
              lineHeight: '1.5',
              textShadow: '4px 4px 0 #4CAF50',
            }}
          >
            TÉRMINOS Y PRIVACIDAD
          </h1>

          <p className="text-[#3a7d3a]">
            Consultá nuestros documentos legales
          </p>

        </div>

        {/* BUTTONS */}
        <div className="mb-8 flex flex-col gap-4 md:flex-row">

          <button
            onClick={() => setSelectedDocument('terminos')}
            className={`
              flex-1 px-6 py-4 text-sm font-bold transition
              ${
                selectedDocument === 'terminos'
                  ? 'bg-[#1a3d1a] text-white shadow-[6px_6px_0px_#4CAF50]'
                  : 'bg-white text-[#1a3d1a] shadow-[4px_4px_0px_#b5b5b5]'
              }
            `}
            style={{
              fontFamily: "'Press Start 2P', monospace",
            }}
          >
            TÉRMINOS
          </button>

          <button
            onClick={() => setSelectedDocument('privacy')}
            className={`
              flex-1 px-6 py-4 text-sm font-bold transition
              ${
                selectedDocument === 'privacy'
                  ? 'bg-[#1a3d1a] text-white shadow-[6px_6px_0px_#4CAF50]'
                  : 'bg-white text-[#1a3d1a] shadow-[4px_4px_0px_#b5b5b5]'
              }
            `}
            style={{
              fontFamily: "'Press Start 2P', monospace",
            }}
          >
            PRIVACIDAD
          </button>

        </div>

        {/* PDF VIEWER */}
        <div className="overflow-hidden border-4 border-[#1a3d1a] bg-white shadow-[10px_10px_0px_#4CAF50]">

          <iframe
            title="PDF Viewer"
            src={
              selectedDocument === 'terminos'
                ? terminosPDF
                : privacyPDF
            }
            className="h-[85vh] w-full"
          />

        </div>

      </div>

    </div>
  );
};

export default TerminosPrivacy;